import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PageHeaderComponent } from '../../components/page-header/page-header.component';
import { MiscService } from '../../services/misc.service';

@Component({
    selector: 'mobilize-payment-response',
    imports: [
        PageHeaderComponent,
        RouterLink
    ],
    templateUrl: './payment-response.component.html',
    styleUrl: './payment-response.component.scss'
})
export class PaymentResponseComponent implements OnInit {

    private _route = inject(ActivatedRoute);
    private _misc = inject(MiscService);

    params: any;
    pageTitle = 'Confirmare proces plata';

    constructor() {
        this._route.queryParams.subscribe(rsp => {
            this.params = rsp;
        })
    }

    ngOnInit(): void {
        this._misc.openFeedbackIfAllowed();
    }
}
